import { render } from "./ChartsComponent.vue?vue&type=template&id=56ce5f7a"
import script from "./ChartsComponent.vue?vue&type=script&lang=js"
export * from "./ChartsComponent.vue?vue&type=script&lang=js"

import "./ChartsComponent.vue?vue&type=style&index=0&id=56ce5f7a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__